<template>
  <div class="selecet_products">
    <Flow v-bind:step="2"/>
    <div class="subscription_wrap">
      <div v-show="!loading" class="subscription_itemList boxs2">
        <h2 class="subscription_title ab">定期購入している商品  (変更前)</h2>
        <div v-if="subscriptionItems.length != 0" class="product_list bg_white">
          <div class="subscription_item" v-for="value in subscriptionItems">
            <span class="item_count rb">{{ value.orderCount }}</span>
            <div class="item_image">
              <img :src="imagePath + value.product.imagePath" :alt="value.product.productName" v-on:error="imageError" :data-noimage="imagePath + value.product.noImagePath">
            </div>
            <p class="item_name ab">{{ value.product.productName }}</p>
            <p v-if="value.goodDeal" class="good_deal_description ab">{{ value.goodDealDescription }}</p>
          </div>
        </div>
        <div class="product_list bg_white" v-else>
          <p v-show="!loading" class="no_subscription_text ab">現在、定期購入している商品 はありません。</p>
        </div>
      </div>

      <h2 v-show="!loading" class="subscription_title ab">新しい定期購入選択</h2>

      <ProductList :bc="subNowBC" v-on:existRepeatItem="existRepeatItem" v-on:preCartItems="preCartItems" />

      <div class="service_wrap bg_white pt16 pb48 mt12">
        <a href="#" class="btn_blue" @click.stop.prevent="confirmSubmit()">次へ</a>
        <router-link class="btn_delete btn_back" :to="{ name: 'subSelectBC' }">戻る</router-link>
      </div>
    </div>
<ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>

</template>

<script>
import Flow from '@/components/subscription/Flow'
import ProductList from '@/components/subscription/ProductList'
import Config from '@/config/config'
import ErrorModal from '@/components/common/ErrorModal'
import scrollPosition from '@/model/scrollPosition';
import CheckOrder from '@/model/checkSelectRepeatOrder';
import { mapGetters } from 'vuex';

export default {
  props: ['subNowBC'],
  components: {
    Flow,
    ProductList,
    ErrorModal
  },
  data () {
    return {
      isModalOpen: false,
      errorMessage: '商品が選択されていません',
      imagePath: Config.APIURL,
      loading: true,
      nowBC: this.subNowBC,
      subscriptionItems: [],
    };
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;

    },
    preCartItems(item) {
      // 選択されたらストレージに保存（ProductListコンポーネントからデータを受け取っている）
      localStorage.setItem('sub' + this.nowBC + 'preCart', JSON.stringify(item));
    },
    existRepeatItem(item) {
      // this.subscriptionItems.replace(0, item.length)
      this.subscriptionItems.push(...item);
      this.loading = false;
    },
    setSubscriptioncheckSelectRepeatOrder(result) {
      this.$store.commit('setSubscriptioncheckSelectRepeatOrder', result);
    },
    confirmSubmit() {
      // const repeatItemList = JSON.parse(localStorage.getItem('repeatItemList'));
      // let bool = [];
      // for (var i = 0; i < repeatItemList.length; i++) {
      //   bool.push(repeatItemList[i].itemList.some(val => val.repeatOrder));
      // }
      // let boolesn = bool.some(val => val);
      let result = CheckOrder.checkSelectRepeatOrder();
      this.setSubscriptioncheckSelectRepeatOrder(result);
      if(this.subscriptionItems.length == 0 && !this.checkSelectRepeatOrder) {
        this.modalOpen();
        return false;
      }
      this.$router.push({ name: 'subSelectProductsList' });
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    }
  },
  computed: mapGetters(['checkSelectRepeatOrder']),
  created () {
    let storageNowBC = localStorage.getItem('subNowBC');
    storageNowBC ? this.nowBC = storageNowBC : '';
     // = localStorage.getItem('subNowBC');
    // let values = JSON.parse(localStorage.getItem('sub' + this.nowBC + 'preCart'));
    // if (values != null) {
    //   for (var i = 0; i < values.length; i++) {
    //     this.cartData.push(values[i]);
    //   }
    // }

  },
  watch: {
  }
}
</script>

<style lang="css" scoped>
.no_subscription_text {
  color: #747474;
  font-size: 16px;
  padding: 14px 14px 32px;
}
>>> .content_title {
  width: 173px;
}

>>> .product_list {
  display: flex;
  /* justify-content: space-between; */
  margin-top: 16px;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px;
}

>>> .product_item {
  background: #FFFFFF;
  border: 1px solid #AAAAAA;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 10px;
  position: relative;
  text-align: center;
  width: 120px;
}

>>> .subscription_wrap .product_item {
  background: #EBEBEB;
}


>>> .product_item:not(:first-child) {
  margin-left: 18px;
}

>>> .product_item::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  border-radius: 100px;
  content: '';
  height: 20px;
  left: 6.61%;
  position: absolute;
  top: 4.21%;
  width: 20px;
}

>>> .product_item.select {
  background: #00FFFF;
  border: 2px solid #0E9AFF;
}

>>> .product_item.select::after {
  background: #00C2FF;
  border-radius: 100px;
  content: '';
  height: 12px;
  left: 13px;
  position: absolute;
  top: 14px;
  width: 12px;
}

>>> .beauty_wrap .product_item.select::after,
.goods_wrap .product_item.select::after,
.service_wrap .product_item.select::after {
  top: 14px;
}

>>> .product_image {
  width: 100px;
}

>>> .product_title {
  font-size: 8px;
  font-weight: bold;
  margin-top: 6px;
}

>>> .product_price {
  font-size: 18px;
}

>>> .product_point {
  font-size: 12px;
}

>>> .yen {
  font-size: 14px;
}

>>> .point {
  font-size: 10px;
}


.btn_blue {
  margin-top: 26px;
}

.subscription_wrap .btn_blue {
  margin-top: 17px;
}

.subscription_wrap .product_list {
  margin-top: 0;
}

.subscription_wrap .product_list {
  padding: 16px;
}

.subscription_item {
  background: #FFFFFF;
  border: 1px solid #AAAAAA;
  border-radius: 8px;
  position: relative;
  padding: 14px 10px;
  width: 120px;
}

.subscription_item:not(:first-child) {
  margin-left: 18px;
}

.item_count {
  align-items: center;
  border: 1px solid #AAAAAA;
  border-radius: 100px;
  display: flex;
  height: 26px;
  justify-content: center;
  left: 8px;
  line-height: 1;
  position: absolute;
  top: 8px;
  width: 26px;
}

.item_image {
  height: 90px;
  margin: auto;
  width: 100px;
}

.item_image img {
  height: 100%;
}

.item_name {
  font-size: 10px;
  margin-top: 5px;
  text-align: center;
  white-space: pre-wrap;
}

.btn_back {
  margin-top: 26px;
}

.good_deal_description {
  font-size: 10px;
  margin: 4px auto 0;
  text-align: center;
  width: 70%;
  white-space: break-spaces;
}

</style>



// WEBPACK FOOTER //
// src/views/subscription/SubSelectProducts.vue